import EntityIdentifier from "./EntityIdentifier";
import Ratings from "./Ratings";
class Entity {
    branche;
    companyId;
    identifiers;
    lei;
    name;
    ratings;
    shortName;
    constructor(response) {
        this.branche = response.branche;
        this.companyId = response.companyId;
        this.identifiers = response.identifiers?.map(i => new EntityIdentifier(i));
        this.lei = response.lei;
        this.name = response.name;
        this.ratings = response.ratings !== undefined ? new Ratings(response.ratings) : undefined;
        this.shortName = response.shortName;
    }
}
export default Entity;
